module.exports = __webpack_public_path__ + "02_short_gold.b548f477.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_short_gold.png
// module id = dJVw
// module chunks = 0